export default function calcs() {
  "use strict";
  // object for customn dropdown    select
  function CustomSelect(el) {
    this.el = el;
    this.placeholder = el.find(".cs-placeholder");
    this.items = el.find(".cs-options");
    this.hiddens = this.items.find(".hidden-cbx");
    this._init();
  }

  CustomSelect.prototype._init = function () {
    var self = this;
    var $root = this.el;

    // open/close dropdown
    self.placeholder.on("click", function (e) {
      $root.toggleClass("cs-open");
    });

    self.el.on("change", function (e, curChecked) {
      // синхронизируем значение placeholder c текущим выбранным элементом списка
      // берем из атрибута data-default элемента cs-placeholder, если у списка значение по-умолчанию не входит в элементы списка
      var str = "",
        $current;
      if (typeof curChecked !== "undefined") {
        str = curChecked;
      } else {
        $current = self.hiddens.filter(":checked");
        if ($current.length > 0) str = $current.next().html();
        else str = self.placeholder.data("default");

        // на случай, если предыдущая операция "запортила" str
        if (typeof str == "undefined") str = "";
      }
      self.placeholder.html(str);
    });
    // if item is selected
    self.items.on("change", ".hidden-cbx", function (e) {
      e.stopPropagation();
      // список должен закрыться
      //$root.removeClass('cs-open'); // по идее это должно быть в событии click
      // а placeholder изменится
      // может так поступить только, если строго соблюдаем разметку input > label
      //self.placeholder.html($(this).next().html());
      self.el.trigger("change", $(this).next().html());
      $("#selectedCurrencyPair")
        ? $("#selectedCurrencyPair").text($(this).next().html())
        : null;
    });
    self.items.on("click", ".hidden-cbx", function (e) {
      // список должен закрыться
      $root.removeClass("cs-open");
    });

    // close the select element if the target it´s not the select element or one of its descendants..
    $(document).on("click", function (ev) {
      var $target = $(ev.target);
      // если мы находимся на самом элементе, то выходим из ф-ции, поскольку событие на элементе уже отработало,
      // иначе закрываем список
      if ($target.closest($root).length || $target.is($root)) return;
      if ($root.hasClass("cs-open")) {
        // && target !== self.selEl && !hasParent( target, self.selEl )
        $root.removeClass("cs-open");
      }
    });
  };

  // методы калькуляторов
  var appForex = {
    messages: {
      // lang: "en",
      // title: "Warning",
      // 'high-previous-price': 'Enter previous High price, please.',
      // 'low-previous-price': 'Enter previous Low price, please.',
      // 'close-previous-price': 'Enter previous Close price, please.',
      // 'open-price': "You haven't entered Open price, DeMark's pivot points won't be calculated!",
      // 'high-trend-price': "Enter trend High price, please.",
      // 'low-trend-price': "Enter trend Low price, please.",
      // 'low-high-price': 'Low price should not be higher than High price!',
      // 'position-size': 'Enter your position size, please.',
      // 'current-price': 'Enter the current price, please.',
      // 'ask-price': " Ask price",
      // 'bid-price': " Bid price",
      // 'current': "Current ",
      // 'account-size': 'Enter your account size, please.',
      // 'risk-ratio': 'Enter the risk ratio, please.',
      // 'stop-loss': 'Enter your stop-loss, please.',
      // 'swap-money': "Swap with Money",
      // 'swap-risk': "Swap with Risk",
      // 'point-a': 'Enter the Point A price, please.',
      // 'point-b': 'Enter the Point B price, please.',
      // 'point-c': 'Enter the Point C price, please.',
      en: {
        'high-previous-price': 'Enter previous High price, please.',
        'low-previous-price': 'Enter previous Low price, please.',
        'close-previous-price': 'Enter previous Close price, please.',
        'open-price': "You haven't entered Open price, DeMark's pivot points won't be calculated!",
        'high-trend-price': "Enter trend High price, please.",
        'low-trend-price': "Enter trend Low price, please.",
        'low-high-price': 'Low price should not be higher than High price!',
        'position-size': 'Enter your position size, please.',
        'current-price': 'Enter the current price, please.',
        'ask-price': " Ask price",
        'bid-price': " Bid price",
        'current': "Current ",
        'account-size': 'Enter your account size, please.',
        'risk-ratio': 'Enter the risk ratio, please.',
        'stop-loss': 'Enter your stop-loss, please.',
        'swap-money': "Swap with Money",
        'swap-risk': "Swap with Risk",
        'point-a': 'Enter the Point A price, please.',
        'point-b': 'Enter the Point B price, please.',
        'point-c': 'Enter the Point C price, please.'
      },
      ru: {
        'high-previous-price': 'Введите предыдущую High цену, пожалуйста.',
        'low-previous-price': 'Введите предыдущую Low цену, пожалуйста.',
        'close-previous-price': 'Введите предыдущую цену закрытия, пожалуйста.',
        'open-price': "Вы не ввели цену открытия, уровни ДеМарка не будут рассчитаны!",
        'high-trend-price': "Введите наивысшую цену на тренде, пожалуйста.",
        'low-trend-price': 'Введите низшую цену на тренде, пожалуйста.',
        'low-high-price': 'Низшая цена должна быть ниже наивысшей!',
        'position-size': 'Пожалуйста, введите размер позиции.',
        'current-price': 'Пожалуйста, введите текущую цену.',
        'ask-price': "цена покупки на ",
        'bid-price': "цена продажи на ",
        'current': "Текущая ",
        'account-size': 'Пожалуйста, введите размер счета.',
        'risk-ratio': 'Пожалуйста, введите уровень допустимого риска.',
        'stop-loss': 'Пожалуйста, введите стоп-лосс.',
        'swap-money': "Переключить на деньги",
        'swap-risk': "Переключить на риск",
        'point-a': 'Введите цену в точке A, пожалуйста.',
        'point-b': 'Введите цену в точке B, пожалуйста.',
        'point-c': 'Введите цену в точке C, пожалуйста.'
      },
      es: {
        'high-previous-price': 'Por favor, entre el precio máximo.',
        'low-previous-price': 'Por favor, entre el precio mínimo.',
        'close-previous-price': 'Por favor, entre el precio de cerrada.',
        'open-price': "Usted no han entrado el precio de apertura, ¡los puntos de pivote de DeMark no estarán calculados!",
        'high-trend-price': "Por favor, entre el precio máximo.",
        'low-trend-price': "Por favor, entre el precio mínimo.",
        'low-high-price': '¡El precio mínimo debe ser inferior al precio máximo!',
        'position-size': 'Por favor, entre su tamaño de posición.',
        'current-price': 'Por favor, entre el precio corriente.',
        'ask-price': "Precio de oferta",
        'bid-price': "Precio de demanda",
        'current': "Corriente ",
        'account-size': 'Por favor, entre el tmaño de su cuenta.',
        'risk-ratio': 'Por favor, entre la relación del riesgo.',
        'stop-loss': 'Por favor, entre su stop-loss.',
        'swap-money': "Intercambiar con dinero",
        'swap-risk': "Intercambiar con riesgo",
        'point-a': 'Por favor, entre el punto A.',
        'point-b': 'Por favor, entre el punto B.',
        'point-c': 'Por favor, entre el punto C.'
      },
      cn: {
        'high-previous-price': '请输入先前的高位价格。',
        'low-previous-price': '请输入先前的低位价格。',
        'close-previous-price': '请输入先前的收盘价格。',
        'open-price': "您没有输入开盘价，不能计算DeMark's枢轴点。",
        'high-trend-price': '请输入趋势高位的价格。',
        'low-trend-price': '请输入趋势低位的价格。',
        'low-high-price': '低位的价格不应高于高位的价格！',
        'position-size': '请输入您的头寸数量。',
        'current-price': '请输入当前价格。',
        'ask-price': " 卖价",
        'bid-price': " 买价",
        'current': "当前价格 ",
        'account-size': '请输入您账户的资金量。',
        'risk-ratio': '请输入风险比率。',
        'stop-loss': '请输入您的止损。',
        'swap-money': "交换资金",
        'swap-risk': "交换风险",
        'point-a': '请输入A点的价位。',
        'point-b': '请输入B点的价位。',
        'point-c': '请输入C点的价位。'
      },
      zh: {
        'high-previous-price': '請輸入先前的高位價格。',
        'low-previous-price': '請輸入先前的低價價格。',
        'close-previous-price': '請輸入先前的收盤價格。',
        'open-price': "您沒有輸入開盤價，不能計算DeMark's樞軸點。",
        'high-trend-price': '請輸入趨勢高點的價格。',
        'low-trend-price': '請輸入趨勢低點的價格。',
        'low-high-price': '低位的價格不應高於高點的價格！',
        'position-size': '請輸入您的頭寸數量。',
        'current-price': '請輸入當前價格。',
        'ask-price': " 賣價",
        'bid-price': " 買價",
        'current': "目前價格 ",
        'account-size': '請輸入您帳戶的資金量。',
        'risk-ratio': '請輸入風險比率。',
        'stop-loss': '請輸入您的停損。',
        'swap-money': "交換資金",
        'swap-risk': "交換風險",
        'point-a': '請輸入A點的價位。',
        'point-b': '請輸入B點的價位。',
        'point-c': '請輸入C點的價位。'
      },
      ar: {
        'high-previous-price': 'فضلا , ادخل السعر القمة السابق .',
        'low-previous-price': 'فضلا , ادخل سعر القاع السابق .',
        'close-previous-price': 'فضلا , ادخل سعر الإغلاق السابق .',
        'open-price': "لم تقم بإدخال سعر الافتتاح , وبالتالي فان نقاط بيفوت ديمارك لن يمكن حسابها !",
        'high-trend-price': 'ادخل سعر قمة الترند , فضلا .',
        'low-trend-price': 'ادخل سعر قاع الترند , فضلا .',
        'low-high-price': 'سعر القاع لا يجب أبدا ان يكون اعلي من سعر القمة !',
        'position-size': 'فضلا , ادخل حجم مركز التداول .',
        'current-price': 'فضلا , ادخل السعر الحالي .',
        'ask-price': " سعر السؤال ",
        'bid-price': " سعر العطاء ",
        'current': "الحالي لزوج",
        'account-size': 'فضلا, ادخل حجم حسابك .',
        'risk-ratio': 'فضلا , ادخل معدل المخاطرة .',
        'stop-loss': 'فضلا, ادخل أمر وقف الخسارة .',
        'swap-money': "المبادلة مع المال",
        'swap-risk': "المبادلة مع المخاطر",
        'point-a': 'فضلا , ادخل نقطة السعر A .',
        'point-b': 'فضلا , ادخل نقطة السعر B .',
        'point-c': 'فضلا , ادخل نقطة السعر C .'
      },
    },
  };

  // опции калькулятора, там где это нужно, для передачи значений между ф-ми (напримео, чтобы не использовать дата-атрибуты)
  var calcOp = {},
    initCurrencyPriority = function () {
      calcOp.CurrencyPriority = [];
      //CurrencyPriority["XAU"] = 103;
      //CurrencyPriority["XAG"] = 102;
      //CurrencyPriority["OIL"] = 101;
      calcOp.CurrencyPriority["EUR"] = 100;
      calcOp.CurrencyPriority["GBP"] = 90;
      calcOp.CurrencyPriority["AUD"] = 80;
      calcOp.CurrencyPriority["NZD"] = 70;
      calcOp.CurrencyPriority["USD"] = 60;
      calcOp.CurrencyPriority["CAD"] = 50;
      calcOp.CurrencyPriority["CNH"] = 47;
      calcOp.CurrencyPriority["CHF"] = 46;
      calcOp.CurrencyPriority["SGD"] = 45;
      calcOp.CurrencyPriority["DKK"] = 44;
      calcOp.CurrencyPriority["PLN"] = 43;
      calcOp.CurrencyPriority["CCK"] = 42;
      calcOp.CurrencyPriority["HKD"] = 41;
      calcOp.CurrencyPriority["HUF"] = 40;
      calcOp.CurrencyPriority["LVL"] = 39;
      calcOp.CurrencyPriority["NOK"] = 38;
      calcOp.CurrencyPriority["ZAR"] = 36;
      calcOp.CurrencyPriority["SEK"] = 35;
      calcOp.CurrencyPriority["HRK"] = 34;
      calcOp.CurrencyPriority["LTL"] = 33;
      calcOp.CurrencyPriority["MXN"] = 32;
      calcOp.CurrencyPriority["RUB"] = 31;
      calcOp.CurrencyPriority["JPY"] = 30;
    },
    CalcPP = function (f) {
      // для страницы http://localhost/yii/earnforex/pivot-points-calculator/
      var piv, X, r1, r2, r3, s1, s2, s3;
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      if (!f.H.value) {
        openCalcModal(
          appForex.messages[lang][
            "high-previous-price"
          ]
        );
        return false;
      } else if (!f.L.value) {
        openCalcModal(
          appForex.messages[lang][
            "low-previous-price"
          ]
        );
        return false;
      } else if (!f.C.value) {
        openCalcModal(
          appForex.messages[lang][
            "close-previous-price"
          ]
        );
        return false;
      } else if (!f.O.value) {
        openCalcModal(
          appForex.messages[lang]["open-price"]
        );
      }

      f.H.value = f.H.value.replace(",", ".");
      f.L.value = f.L.value.replace(",", ".");
      f.C.value = f.C.value.replace(",", ".");
      f.O.value = f.O.value.replace(",", ".");
      piv = (1 * f.H.value + 1 * f.L.value + 1 * f.C.value) / 3;
      r1 = 2 * piv - f.L.value;
      r2 = piv + 1 * f.H.value - f.L.value;
      r3 = 1 * f.H.value + 2 * (piv - f.L.value);
      s1 = 2 * piv - f.H.value;
      s2 = piv - f.H.value + 1 * f.L.value;
      s3 = f.L.value - 2 * (f.H.value - piv);
      $("#p1").html(Math.round(piv * 10000) / 10000);
      $("#r11").html(Math.round(r1 * 10000) / 10000);
      $("#r21").html(Math.round(r2 * 10000) / 10000);
      $("#r31").html(Math.round(r3 * 10000) / 10000);
      $("#s11").html(Math.round(s1 * 10000) / 10000);
      $("#s21").html(Math.round(s2 * 10000) / 10000);
      $("#s31").html(Math.round(s3 * 10000) / 10000);
      piv = (1 * f.H.value + 1 * f.L.value + 2 * f.C.value) / 4;
      r1 = 2 * piv - f.L.value;
      r2 = piv + 1 * f.H.value - f.L.value;
      s1 = 2 * piv - f.H.value;
      s2 = piv - f.H.value + 1 * f.L.value;
      $("#p2").html(Math.round(piv * 10000) / 10000);
      $("#r12").html(Math.round(r1 * 10000) / 10000);
      $("#r22").html(Math.round(r2 * 10000) / 10000);
      $("#s12").html(Math.round(s1 * 10000) / 10000);
      $("#s22").html(Math.round(s2 * 10000) / 10000);
      var r1c = ((f.H.value - f.L.value) * 1.1) / 12 + 1 * f.C.value;
      var r2c = ((f.H.value - f.L.value) * 1.1) / 6 + 1 * f.C.value;
      var r3c = ((f.H.value - f.L.value) * 1.1) / 4 + 1 * f.C.value;
      var r4c = ((f.H.value - f.L.value) * 1.1) / 2 + 1 * f.C.value;
      var s1c = f.C.value - ((f.H.value - f.L.value) * 1.1) / 12;
      var s2c = f.C.value - ((f.H.value - f.L.value) * 1.1) / 6;
      var s3c = f.C.value - ((f.H.value - f.L.value) * 1.1) / 4;
      var s4c = f.C.value - ((f.H.value - f.L.value) * 1.1) / 2;
      $("#r1c").html(Math.round(r1c * 10000) / 10000);
      $("#r2c").html(Math.round(r2c * 10000) / 10000);
      $("#r3c").html(Math.round(r3c * 10000) / 10000);
      $("#r4c").html(Math.round(r4c * 10000) / 10000);
      $("#s1c").html(Math.round(s1c * 10000) / 10000);
      $("#s2c").html(Math.round(s2c * 10000) / 10000);
      $("#s3c").html(Math.round(s3c * 10000) / 10000);
      $("#s4c").html(Math.round(s4c * 10000) / 10000);
      if (!f.O.value) {
        return false;
      }
      if (1 * f.C.value > 1 * f.O.value) {
        X = 2 * f.H.value + 1 * f.L.value + 1 * f.C.value;
      } else if (1 * f.C.value < 1 * f.O.value) {
        X = 1 * f.H.value + 2 * f.L.value + 1 * f.C.value;
      } else {
        X = 1 * f.H.value + 1 * f.L.value + 2 * f.C.value;
      }
      $("#h1").html(Math.round((X / 2 - f.L.value) * 10000) / 10000);
      $("#l1").html(Math.round((X / 2 - f.H.value) * 10000) / 10000);
      return true;
    },
    CalcFibo = function (f) {
      // //www.earnforex.com/fibonacci-calculator
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      if (!f.H.value) {
        openCalcModal(
          appForex.messages[lang][
            "high-trend-price"
          ]
        );
        return false;
      } else if (!f.L.value) {
        openCalcModal(
          appForex.messages[lang][
            "low-trend-price"
          ]
        );
        return false;
      } else if (1 * f.L.value > 1 * f.H.value) {
        openCalcModal(
          appForex.messages[lang][
            "low-high-price"
          ]
        );
        return false;
      }
      f.H.value = f.H.value.replace(",", ".");
      f.L.value = f.L.value.replace(",", ".");

      var tofix = 4,
        t,
        dif;

      if (
        f.H.value.substring(1, 2) !== "." &&
        f.H.value.substring(1, 2) !== ","
      )
        tofix = 2;
      else tofix = 4;

      dif = 1 * f.H.value - 1 * f.L.value;
      t = f.H.value * 1;
      $("#r0").html(t.toFixed(tofix));
      t = 1 * f.L.value + (dif * 61.8) / 100;
      $("#r1").html(t.toFixed(tofix));
      t = 1 * f.L.value + (dif * 50) / 100;
      $("#r2").html(t.toFixed(tofix));
      t = 1 * f.L.value + (dif * 38.2) / 100;
      $("#r3").html(t.toFixed(tofix));
      t = 1 * f.L.value + (dif * 23.6) / 100;
      $("#r4").html(t.toFixed(tofix));
      t = 1 * f.L.value;
      $("#r5").html(t.toFixed(tofix));

      t = f.L.value * 1;
      $("#r0r").html(t.toFixed(tofix));
      t = 1 * f.H.value - (dif * 61.8) / 100;
      $("#r1r").html(t.toFixed(tofix));
      t = 1 * f.H.value - (dif * 50) / 100;
      $("#r2r").html(t.toFixed(tofix));
      t = 1 * f.H.value - (dif * 38.2) / 100;
      $("#r3r").html(t.toFixed(tofix));
      t = 1 * f.H.value - (dif * 23.6) / 100;
      $("#r4r").html(t.toFixed(tofix));
      t = 1 * f.H.value;
      $("#r5r").html(t.toFixed(tofix));

      return true;
    },
    CalcRR = function (f) {
      var f2 = document.f2,
        r1,
        r2,
        t1,
        t2,
        t3,
        risk1,
        reward1,
        reward2,
        reward3,
        ratio1,
        ratio2,
        ratio3;

      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      if (!f.A.value) {
        openCalcModal(
          appForex.messages[lang]["point-a"]
        );
        return false;
      } else if (!f.B.value) {
        openCalcModal(
          appForex.messages[lang]["point-b"]
        );
        return false;
      } else if (!f.C.value) {
        openCalcModal(
          appForex.messages[lang]["point-c"]
        );
        return false;
      }

      f.A.value = f.A.value.replace(",", ".");
      f.B.value = f.B.value.replace(",", ".");
      f.C.value = f.C.value.replace(",", ".");
      if (1 * f.A.value <= 1 * f.B.value) {
        r1 = 1 * f.B.value - (1 * f.B.value - 1 * f.A.value) * 0.382;
        r2 = 1 * f.B.value - (1 * f.B.value - 1 * f.A.value) * 0.618;
        t1 = r1 + (1 * f.C.value - 1 * f.A.value);
        t2 = 1 * f.B.value + (1 * f.C.value - 1 * f.A.value);
        t3 =
          r1 +
          (1 * f.B.value - 1 * f.A.value) +
          (1 * f.C.value - 1 * f.A.value);
        risk1 = r1 - r2;
        reward1 = t1 - r1;
        reward2 = t2 - r1;
        reward3 = t3 - r1;
      } else {
        r1 = 1 * f.B.value + (1 * f.A.value - 1 * f.B.value) * 0.382;
        r2 = 1 * f.B.value + (1 * f.A.value - 1 * f.B.value) * 0.618;
        t1 = r1 - (1 * f.A.value - 1 * f.C.value);
        t2 = 1 * f.B.value - (1 * f.A.value - 1 * f.C.value);
        t3 =
          r1 -
          (1 * f.A.value - 1 * f.C.value) -
          (1 * f.A.value - 1 * f.B.value);
        risk1 = r2 - r1;
        reward1 = r1 - t1;
        reward2 = r1 - t2;
        reward3 = r1 - t3;
      }
      ratio1 = reward1 / risk1;
      ratio2 = reward2 / risk1;
      ratio3 = reward3 / risk1;

      $("#r1").html(Math.round(r1 * 10000) / 10000);
      $("#r2").html(Math.round(r2 * 10000) / 10000);
      $("#t1").html(Math.round(t1 * 10000) / 10000);
      $("#t2").html(Math.round(t2 * 10000) / 10000);
      $("#t3").html(Math.round(t3 * 10000) / 10000);
      $("#risk1").html(Math.round(risk1 * 10000) / 10000);
      $("#risk2").html(Math.round(risk1 * 10000) / 10000);
      $("#risk3").html(Math.round(risk1 * 10000) / 10000);
      $("#reward1").html(Math.round(reward1 * 10000) / 10000);
      $("#reward2").html(Math.round(reward2 * 10000) / 10000);
      $("#reward3").html(Math.round(reward3 * 10000) / 10000);
      $("#ratio1").html(Math.round(ratio1 * 100) / 100);
      $("#ratio2").html(Math.round(ratio2 * 100) / 100);
      $("#ratio3").html(Math.round(ratio3 * 100) / 100);
      $("table .none").html("–");
      return true;
    },
    CalcPV = function (f) {
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      if (!f.ls.value) {
        openCalcModal(
          appForex.messages[lang][
            "position-size"
          ]
        );
        return false;
      } else if (
        !f.price.value &&
        $(f.currency).filter(":checked").val() !==
          $(f.pair).filter(":checked").val().substring(4, 7)
      ) {
        openCalcModal(
          appForex.messages[lang][
            "current-price"
          ]
        );
        return false;
      }

      f.price.value = f.price.value.replace(",", ".");

      var t,
        UnitCosts,
        SecondAffCur = calcOp.SecondAffCur;

      UnitCosts =
        $(f.currency).filter(":checked").val() !== "JPY" ? 0.0001 : 0.01;

      if (SecondAffCur !== 0) {
        if (calcOp.stype.toLowerCase() === appForex.messages[lang]["ask-price"].toLowerCase()) {
          UnitCosts /=
            SecondAffCur === "JPY" ? f.price.value / 100 : f.price.value;
        } else {
          UnitCosts *=
            SecondAffCur === "JPY" ? f.price.value / 100 : f.price.value;
        }
      }

      document.getElementById("pip").innerHTML = UnitCosts * f.ls.value;
      localStorage.setItem(
        "earnforex_psc_currency",
        $(f.currency).filter(":checked").val()
      );

      return true;
    },
    CalcPosSize = function (f) {
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      if (!f.size.value) {
        openCalcModal(
          appForex.messages[lang]["account-size"]
        );
        return false;
      } else if (!f.risk.value) {
        openCalcModal(
          appForex.messages[lang]["risk-ratio"]
        );
        return false;
      } else if (!f.stop.value) {
        openCalcModal(
          appForex.messages[lang]["stop-loss"]
        );
        return false;
      } else if (
        !f.price.value &&
        $(f.currency).filter(":checked").val() !== calcOp.SecondSelCur
      ) {
        openCalcModal(
          appForex.messages[lang][
            "current-price"
          ]
        );
        return false;
      }

      var t,
        UnitCosts = 0.0001,
        SecondAffCur = calcOp.SecondAffCur;
      if ($(f.currency).filter(":checked").val() === "JPY") UnitCosts = 0.01;

      f.size.value = f.size.value.replace(",", ".");
      f.risk.value = f.risk.value.replace(",", ".");
      f.stop.value = f.stop.value.replace(",", ".");
      f.price.value = f.price.value.replace(",", ".");

      if (f.swapriskmoney.value.toLowerCase() === appForex.messages[lang]["swap-money"].toLowerCase()) {
        t = (f.size.value * f.risk.value) / 100;
        calcOp.elMoney.innerHTML = t.toFixed(2);
      } else {
        t = (f.risk.value / f.size.value) * 100;
        calcOp.elMoney.innerHTML = t.toFixed(2);
      }

      if (SecondAffCur !== 0) {
        if (calcOp.stype.toLowerCase() === appForex.messages[lang]["ask-price"].toLowerCase()) {
          UnitCosts /=
            SecondAffCur === "JPY" ? f.price.value / 100 : f.price.value;
        } else {
          UnitCosts *=
            SecondAffCur === "JPY" ? f.price.value / 100 : f.price.value;
        }
      }
      t =
        f.swapriskmoney.value.toLowerCase() === appForex.messages[lang]["swap-money"].toLowerCase()
          ? calcOp.elMoney.innerHTML / f.stop.value / UnitCosts
          : f.risk.value / f.stop.value / UnitCosts;

      document.getElementById("units").innerHTML = t.toFixed(0);
      t /= 100000;
      document.getElementById("lots").innerHTML = t.toFixed(3);

      localStorage.setItem(
        "earnforex_psc_currency",
        $(f.currency).filter(":checked").val()
      );
      localStorage.setItem(
        "earnforex_psc_currency_pair",
        $(f.pair).filter(":checked").val()
      );
      localStorage.setItem("earnforex_psc_account_size", f.size.value);

      return true;
    },
    makePricetLabel = function (cur, stype, FirstAffCur, SecondAffCur) {
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      if (calcOp.typeLabel === "1") {
        return (
          appForex.messages[lang]["current"] +
          FirstAffCur +
          "/" +
          SecondAffCur +
          stype
        );
      } else if (calcOp.typeLabel === "2") {
        return (
          appForex.messages[lang]["current"] +
          stype +
          FirstAffCur +
          "/" +
          SecondAffCur
        );
      } else {
        return stype + " de " + FirstAffCur + "/" + SecondAffCur + ":";
      }
    },
    ShowForm = function (f) {
      var FirstSelCur = $(f.pair).filter(":checked").val().substring(0, 3),
        SecondSelCur = $(f.pair).filter(":checked").val().substring(4, 7),
        stype,
        FirstAffCur,
        SecondAffCur,
        fcurrency = $(f.currency).filter(":checked").val();
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      calcOp.$moneycur.length && calcOp.$moneycur.html(fcurrency);

      if (fcurrency !== SecondSelCur) {
        if (
          calcOp.CurrencyPriority[fcurrency] >
          calcOp.CurrencyPriority[SecondSelCur]
        ) {
          FirstAffCur = fcurrency;
          SecondAffCur = SecondSelCur;
        } else {
          FirstAffCur = SecondSelCur;
          SecondAffCur = fcurrency;
        }
        calcOp.$ask_price.show();

        stype =
          fcurrency === FirstAffCur
            ? appForex.messages[lang][
                "ask-price"
              ]
            : appForex.messages[lang][
                "bid-price"
              ];
        calcOp.elPricet.innerHTML = `<strong>${makePricetLabel(
          appForex.messages[lang]["current"],
          stype,
          FirstAffCur,
          SecondAffCur
        )}</strong>`;
      } else {
        calcOp.$ask_price.hide();
        FirstAffCur = 0;
        SecondAffCur = 0;
      }

      calcOp.stype = stype;
      calcOp.SecondAffCur = SecondAffCur;
      calcOp.SecondSelCur = SecondSelCur;
    },
    calcExtra_Init = function (f) {
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      initCurrencyPriority();

      calcOp.$moneycur = $(".js-calc-currency");
      calcOp.typeLabel =
        lang === "en" || lang === "cn"
          ? "1"
          : lang === "ru" || lang === "ar"
          ? "2"
          : "3";
      calcOp.elPricet = document.getElementById("pricet");
      calcOp.$ask_price = $(".js-calc-ask-price");

      $(".select-currency, .select-pair").on("change", function () {
        ShowForm(f);
        $("#moneycur, #moneycur2").text($(".js-money").text());
      });

      var t = localStorage.getItem("earnforex_psc_currency");

      if (t !== null) {
        $(f.currency)
          .filter('[value="' + t + '"]')
          .prop("checked", true);
        $(".select-currency").trigger("change");
      }

      var t = localStorage.getItem("earnforex_psc_currency_pair");
      if (t != null) {
        $(f.pair)
          .filter('[value="' + t + '"]')
          .prop("checked", true);
        $(".select-pair").trigger("change");
      }
      var t = localStorage.getItem("earnforex_psc_account_size");
      if (t != null && f.hasOwnProperty("size")) {
        f.size.value = t;
      }

      ShowForm(f);
    },
    SwapRiskMoney = function () {
      var f = this,
        t = calcOp.elMoney.innerHTML;

      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");

      if (f.swapriskmoney.value.toLowerCase() === appForex.messages[lang]["swap-money"].toLowerCase()) {
        $(".js-set-units").addClass("change-units");

        f.swapriskmoney.value = appForex.messages[lang]["swap-risk"];
      } else {
        $(".js-set-units").removeClass("change-units");
        f.swapriskmoney.value = appForex.messages[lang]["swap-money"];
      }

      calcOp.elMoney.innerHTML = f.risk.value;
      f.risk.value = t;

      if (t === "&nbsp;") {
        $("#risk").val("");
      }
    };

  // ---------------------------
  // когда DOM готов обработчики
  $(function () {
    // установить обработчик выпадающих списков
    $(".custom-dropdown").each(function (i) {
      new CustomSelect($(this), i);
    });

    const host = document.getElementById("calculator");

    if (host === null) {
      // массив ф-ций для расчета конкретного калькулятора

      var calculators = {
          CalcPP: CalcPP,
          CalcFibo: CalcFibo,
          CalcPip: CalcPV,
          CalcSize: CalcPosSize,
          CalcRiskReward: CalcRR,
        },
        formulaName = document.f.getAttribute("data-formula");

      if (formulaName === "CalcPip") {
        calcExtra_Init(document.f);
      }

      if (formulaName === "CalcSize") {
        calcExtra_Init(document.f);
        (calcOp.elMoney = document.getElementById("money")),
          $("#swapriskmoney").on("click", SwapRiskMoney.bind(document.f));
      }

      // обработчик на расчет калькулятора
      $(".form-calculator").on("submit", function (e) {
        e.preventDefault();
        calculators[formulaName]($(this).get(0));
        return
      });
    } else {
      /* Gain Loss Percentage Calculator */
      function toArray(list) {
        var array = [];
        for (var i = 0; i < list.length; i++) {
          array[i] = list[i];
        }
        return array;
      }

      function validate(e) {
        /*if(/37|38|39|40|44|46/.test(e.which)){
    return
 }*/

        //if ((e.charCode != 44 && e.charCode != 46 || this.value.indexOf('.|,') != -1) && (e.charCode < 48 || e.charCode > 57)) {
        if (
          e.which !== 8 &&
          e.which !== 0 &&
          e.which !== 46 &&
          e.which !== 44 &&
          (e.which < 48 || e.which > 57)
        ) {
          e.preventDefault();
        }
      }

      // если язык русский ('ru') или испанский ('es'), заменяем точку на запятую
      var lang = document.querySelector('.main-wrap').getAttribute("data-lang");
      var checkLang = /ru|es/;

      //var host             = document.getElementById('calculator')
      //if (host)
      //{
      var canRegainElem = host.querySelector("[data-can-regain]");
      var cannotRegainElem = host.querySelector("[data-cannot-regain]");

      var startInput = host["start-input"];
      var perInput = host.querySelector("[name='per-input']");
      var currentInput = host.querySelector("[name='current-input']");
      var changeInput = host.querySelector("[name='change-input']");

      var stateCheckbox = host.querySelector("[data-state-checkbox]");

      var stateWonTexts = toArray(host.querySelectorAll("[data-state-won]"));
      var stateLostTexts = toArray(host.querySelectorAll("[data-state-lost]"));
      var perTexts = toArray(host.querySelectorAll("[data-per]"));

      var currentText = host.querySelector("[data-current]");

      toArray(host.querySelectorAll('input[type="text"]')).forEach(function (
        elem
      ) {
        elem.addEventListener("keypress", validate);
        elem.addEventListener("blur", function (e) {
          //e.target.value = +e.target.value.replace(',', '.')
          if (e.target === perInput) return;
          this.value = changeSep((+this.value.replace(",", ".")).toFixed(2));
        });
      });

      function hostEventHundler(e) {
        if (e.target !== currentInput && e.target.value < 0) {
          e.target.value = 0;
        }

        calc(e);
      }

      host.addEventListener("keyup", hostEventHundler);
      host.addEventListener("change", hostEventHundler);

      var cur = {};

      function changeSep(value) {
        if (checkLang.test(lang)) {
          return value.toString().replace(".", ",");
        } else {
          return value.toString().replace(",", ".");
        }
      }

      function calc(e) {
        cur = {
          start: +startInput.value.replace(",", "."),
          current: +currentInput.value.replace(",", "."),
          per: +perInput.value.replace(",", "."),
          change: +changeInput.value.replace(",", "."),
          status: stateCheckbox.checked,
        };

        if (isNaN(cur.start)) startInput.value = cur.start = 0;
        if (isNaN(cur.current)) currentInput.value = cur.current = 0;
        if (isNaN(cur.per)) perInput.value = cur.per = 0;
        if (isNaN(cur.change)) changeInput.value = cur.change = 0;

        current = isNaN(current) ? 0 : current.toFixed(2);
        per = isNaN(per) ? 0 : per;
        change = isNaN(change) ? 0 : change.toFixed(2);
        balanceDiff = isNaN(balanceDiff) ? 0 : balanceDiff.toFixed(2);

        if (
          (cur.start && cur.per) ||
          (cur.start && cur.change) ||
          (cur.start && cur.current) ||
          (cur.change && cur.current) ||
          (cur.change && cur.per)
        ) {
          var start;
          var current;
          var per;
          var change;
          var balanceDiff;

          var setStartInput = false;

          var preventSetStart;
          var preventSetCurrent;
          var preventSetInputPer = false;
          var preventSetChange;

          var isWon = cur.status;

          if (e && e.target) {
            switch (e.target) {
              case stateCheckbox:
                start = cur.start;
                balanceDiff = isWon ? +cur.change : -+cur.change;
                current = cur.start + balanceDiff;
                per = Math.abs((balanceDiff / cur.start) * 100);

                break;

              case startInput:
                start = cur.start;
                current = cur.current ? cur.current : cur.change;
                balanceDiff = current - start;
                per = Math.abs((balanceDiff / start) * 100);

                setStartInput = false;

                preventSetStart = true;

                startInput.dataset.setByUser = start;

                break;

              case currentInput:
                if (!startInput.value) {
                  setStartInput = true;
                  start = cur.current + cur.change;
                } else {
                  start = cur.start;
                }

                current = cur.current;
                balanceDiff = cur.current - start;
                per = Math.abs((balanceDiff / cur.start) * 100);

                preventSetCurrent = true;

                break;

              case changeInput:
                if (!startInput.value) {
                  setStartInput = true;
                  start = cur.current + cur.change;
                } else {
                  start = cur.start;
                }

                balanceDiff = isWon ? +cur.change : -+cur.change;
                per = Math.abs((balanceDiff / cur.start) * 100);
                current = cur.start + balanceDiff;

                preventSetChange = true;

                break;

              case perInput:
                preventSetInputPer = true;

                start = cur.start;

                balanceDiff = isWon
                  ? (cur.start * cur.per) / 100
                  : -((cur.start * cur.per) / 100);
                current = cur.start + balanceDiff;
                per = cur.per;

                break;
            }
          } else {
            start = cur.start;
            balanceDiff = start - cur.current;
            current = cur.current ? cur.current : start + balanceDiff;
            per = Math.abs((balanceDiff / start) * 100);
          }

          current = Math.round(current * 100) / 100;
          per = Math.round(per * 10) / 10;
          per = isFinite(per) ? per : "";
          change = Math.round(change * 100) / 100;
          balanceDiff = Math.round(balanceDiff * 100) / 100;

          if (isNaN(start)) {
            setStartInput = true;
            start = 0;
            startInput.value = 0;
          }

          current = isNaN(current) ? 0 : current.toFixed(2);
          per = isNaN(per) ? 0 : per;
          change = isNaN(change) ? 0 : change.toFixed(2);
          balanceDiff = isNaN(balanceDiff) ? 0 : balanceDiff.toFixed(2);

          if (
            e &&
            e.target.value &&
            e.target.value[e.target.value.length - 1] !== "." &&
            e.target.value[e.target.value.length - 1] !== ","
          ) {
            if (!preventSetStart) setStart(start, setStartInput);
            setState(balanceDiff, preventSetChange);
            setPer(per, balanceDiff, current, preventSetInputPer);
            if (!preventSetCurrent) setCurrent(current);
          }

          // прячем / отображаем 3-ю строку
          canRegainElem.style.display =
            +balanceDiff + 0 === 0 || start <= 0 || current <= 0
              ? "none"
              : "block";
          cannotRegainElem.style.display =
            start <= 0 || current <= 0 ? "block" : "none";
        }
      }

      function setStart(start, setStartInput) {
        if (setStartInput) startInput.value = changeSep(start.toFixed(2));
      }
      function setCurrent(current) {
        currentInput.value = changeSep(current);
      }
      function setPer(per, change, current, preventSetInputPer) {
        if (!preventSetInputPer) {
          perInput.value = changeSep(per);
        }

        var per =
          Math.round(Math.abs((change / current) * 100 * 10)) / 10 + "%";

        perTexts.forEach(function (elem) {
          elem.textContent = changeSep(per);
        });
      }
      function setState(balanceDiff, preventSetChange) {
        var status = +balanceDiff >= 0 ? true : false;

        stateWonTexts.forEach(function (elem) {
          elem.style.display = +balanceDiff >= 0 ? "none" : "inline-block";
        });
        stateLostTexts.forEach(function (elem) {
          elem.style.display = +balanceDiff >= 0 ? "inline-block" : "none";
        });

        // stateCheckbox.setAttribute("data-status", status);

        balanceDiff = Math.abs(+balanceDiff);

        if (!preventSetChange)
          changeInput.value = changeSep(balanceDiff.toFixed(2));

        perTexts.forEach(function (elem) {
          elem.classList[status ? "remove" : "add"]("state-won-text");
          elem.classList[status ? "add" : "remove"]("state-lost-text");
        });
      }

      calc();
      /* /Gain Loss Percentage Calculator */
    }
  });

  function openCalcModal(text) {
    document.querySelector("#calc-modal__text").innerText = text;
    document.querySelector(".calc-modal").classList.add("--open");
  }
};
